/** Maps table column field to API sortBy parameter */
export const COLUMN_FIELD_TO_SORT: Record<string, string> = {
  index: 'partnerNumber',
  name: 'name',
  shares: 'sharesCount.actual',
};

export const PARTNER_NUMBER_SORT_BY = 'partnerNumber';

export const DEFAULT_SORT_BY = 'sharesCount.actual';
export const DEFAULT_SORT_ORDER = 'desc';

/** react-data-table column id (1-based) per API sortBy field */
export const SORT_FIELD_ID_BY_API: Record<string, number> = {
  partnerNumber: 1,
  name: 2,
  'sharesCount.actual': 5,
};
